export const PRODUCTION_PLAN = {
  demo: "Démo",
  autonomy: "Pilotage",
  supported: "Labelisation",
};
